const {
  endpoints: {
    core,
    bucket,
    dashboard,
    baseUrl,
  }
} = window.freedomeConfig;

const endpoints = {
  core,
  bucket,
  dashboard,
  baseUrl,
};

export default endpoints;
